import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getParsedCookies(): Record<string, string> {
  // Split the document.cookie string into individual cookies
  const cookies = document.cookie.split(';');

  // Create an object to store the parsed cookies
  const cookieObj: Record<string, string> = {};

  // Loop through each cookie
  cookies.forEach((cookie) => {
    // Split the cookie into name and value
    let [name, value] = cookie.split('=');

    // Trim whitespace from the name and decode the value
    name = name.trim();
    value = decodeURIComponent(value);

    // Add the cookie to the object
    cookieObj[name] = value;
  });

  return cookieObj;
}

export const INPUT_DEBOUNCE_TIME = 500;

export function hasCrumb<T extends object>(obj: T): obj is T & { crumb: string } {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    'crumb' in obj &&
    typeof (obj as { crumb: string }).crumb === 'string'
  );
}

export type Language = 'en' | 'ua';

export const getShareStoryLinkMessage = (language: Language, link: string) => {
  switch (language) {
    case 'en': {
      return `Hey! I’m using an app called Family Dots to collect and save special stories from our family’s past.\nI’d love to hear your memories and thoughts!\n\nJust click this link to answer a few meaningful questions:\n👉 ${link}\n\nYour answers will be saved and shared privately with me — it’s like writing a mini autobiography one question at a time 😊\n\nThanks so much for taking the time!`;
    }
    case 'ua': {
      return `Привіт! Я користуюсь додатком Family Dots, щоб зібрати та зберегти особливі сімейні історії.\nМені б дуже хотілося почути твої спогади та думки!\n\nПросто натисни на це посилання та відповідай на кілька важливих запитань:\n👉 ${link}\n\nТвої відповіді збережуться та будуть доступні лише мені — це ніби невелика автобіографія, написана по частинах 😊`;
    }
  }
};
